/* eslint-disable import/prefer-default-export */
import Types from './Types';

const handleLoader = fetchName => {
	return ({
		type: Types.API_HANDLE_TIPRANKS_LOADER,
		fetchName
	});
};

const requestTipRanksBySymbol = (symbol, successCallback) => {
	const result = {
		type: Types.API_CIBC_REQUEST_WATCHLIST_NAMES,
		endPoint: `/tipranks/${symbol}`,
		ajaxType: 'GET',
		onSuccess: successCallback,
		loader: handleLoader,
		fetchName: 'fetchingTipranksBySymbol'
	};

	return result;
};

const requestTipRanksToken = successCallback => {
	const result = {
		type: Types.API_CIBC_REQUEST_WATCHLIST_NAMES,
		endPoint: '/tipranksToken',
		ajaxType: 'GET',
		onSuccess: successCallback,
		loader: handleLoader,
		fetchName: 'fetchingTipranksToken'
	};

	return result;
};

export {
	requestTipRanksBySymbol,
	requestTipRanksToken
};
